import React, {useState} from 'react';
import {
  OccurrenceProps,
  OccurenceTargetEnum,
  translatedOccurrenceProps,
} from '../types';
import {useParams} from 'react-router-dom';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';
import useCreateOrderOccurrence from '../hooks/use-create-order-occurrence';
import useApiQuery from 'shared/hooks/use-api-query';
import {Operators} from 'shared/migration-components/filter-list/types';
import {
  AccessControlProps,
  DeliveryManStatusEnum,
} from 'modules/access-controls/types';

const CreateOccurrence: React.FC = () => {
  const {id} = useParams();
  const {getTextArea, getSelect, getPriceInput} =
    useFormInputs<OccurrenceProps>();
  const [payer, setPayer] = useState<OccurenceTargetEnum>();
  const [receiver, setReceiver] = useState<OccurenceTargetEnum>();

  const {data = [], isLoading} = useApiQuery<AccessControlProps[]>({
    url: '/access-controls',
    params: {
      page: 0,
      limit: 50,
      orderBy: 1,
      orderField: 'id',
      projection: 'userId userName',
      isDeliveryManAccessControl: {
        operator: Operators.Equals,
        value: true,
      },
      deliveryManStatus: {
        operator: 'notEqual',
        value: DeliveryManStatusEnum.DISABLED,
      },
      status: {operator: Operators.Equals, value: 'approved'},
    },
  });

  return (
    <Creation
      onSubmit={() => useCreateOrderOccurrence(id!)}
      translationKey={translatedOccurrenceProps}
      onFormStateChange={(data) => {
        if (data.payer && data.payer !== payer) setPayer(data.payer);
        if (data.receiver && data.receiver !== receiver)
          setReceiver(data.receiver);
      }}
      inputs={[
        getSelect({
          name: 'description',
          data: [
            'Entrega extra',
            'Retorno de pedido',
            'Aviso de pedido',
            'Pedido danificado',
            'Pedido não estava pronto',
            'Compra de produtos',
          ].map((description) => ({
            label: description,
            value: description,
          })),
        }),
        getPriceInput({name: 'value'}),
        getSelect({
          name: 'payer',
          data: [
            {label: 'Empresa', value: OccurenceTargetEnum.COMPANY},
            {label: 'Cidade', value: OccurenceTargetEnum.CITY},
            {label: 'Entregador', value: OccurenceTargetEnum.DELIVERY_MAN},
          ].filter((item) => item.value !== receiver),
        }),
        getSelect({
          name: 'receiver',
          data: [
            {label: 'Empresa', value: OccurenceTargetEnum.COMPANY},
            {label: 'Cidade', value: OccurenceTargetEnum.CITY},
            {label: 'Entregador', value: OccurenceTargetEnum.DELIVERY_MAN},
          ].filter((item) => item.value !== payer),
        }),
        getSelect({
          name: 'deliveryManId',
          hidden: (data) =>
            data.payer !== OccurenceTargetEnum.DELIVERY_MAN &&
            data.receiver !== OccurenceTargetEnum.DELIVERY_MAN,
          data: data.map(({userId, userName}) => ({
            label: userName!,
            value: userId,
          })),
          isLoading,
        }),
        getTextArea({name: 'observation'}),
      ]}
    />
  );
};

export default CreateOccurrence;
